const numberConverter = num => num && Number.parseFloat(num).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')

export default numberConverter



// WEBPACK FOOTER //
// ./src/utils/tuition/numberForCurrency.js